import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import Loading from 'vue-loading-overlay'
Vue.use(Loading);
import 'vue-loading-overlay/dist/vue-loading.css'

import EventBus from './utils/event-bus'
Vue.prototype.eventBus = EventBus;

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Multiselect from "vue-multiselect";
Vue.component('multiselect', Multiselect);
import 'vue-multiselect/dist/vue-multiselect.min.css'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import CpfValidator from './utils/validators/cpf/cpf.validator'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('cpf', {
  ...CpfValidator,
  message: "O campo {_field_} possui um CPF inválido"
})

// Validation Rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: pt_BR.messages[rule]
  });
}

Vue.config.productionTip = false

import Api from './utils/api'
Vue.prototype.api = Api;

import moment from 'moment'
Vue.prototype.moment = moment;
Vue.prototype.moment.locale('pt-BR');

import VueSwal from 'vue-swal'
Vue.use(VueSwal);

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
